module.exports = __webpack_public_path__ + "media/application/images/ui/icon-comments-50428b67030e60827473f28d1682774a.png";